module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_number_03_yellow-b601e7bb8a9dd7b059f1d528d509c55a.svg";